// extracted by mini-css-extract-plugin
module.exports = {"container":"KIJAa_mQ","wrapper":"rZBlGliJ","img":"NtBaOVpF","title":"TAegIPTc","description":"ilFTMgGM"};